/** CSV records, including escaped quotes and newlines inside quoted fields. */
export function parseFinanceCsv(text: string, delimiter: string): string[][] {
  const records: string[][] = [];
  let row: string[] = [], cell = '', quoted = false, closed = false;
  const input = text.replace(/^\uFEFF/, '');
  const finishCell = () => { row.push(cell.trim()); cell = ''; closed = false; };
  const finishRow = () => { finishCell(); if (row.some(value => value !== '')) records.push(row); row = []; };
  for (let i = 0; i < input.length; i++) {
    const char = input[i];
    if (quoted) {
      if (char === '"') {
        if (input[i + 1] === '"') { cell += '"'; i++; }
        else { quoted = false; closed = true; }
      } else cell += char;
    } else if (char === delimiter) finishCell();
    else if (char === '\r' || char === '\n') {
      finishRow();
      if (char === '\r' && input[i + 1] === '\n') i++;
    } else if (char === '"' && !cell.trim() && !closed) { cell = ''; quoted = true; }
    else if (char === '"' || (closed && char.trim())) throw new Error('Ungültige Anführungszeichen in der CSV-Datei.');
    else cell += char;
  }
  if (quoted) throw new Error('Nicht geschlossenes Anführungszeichen in der CSV-Datei.');
  finishRow();
  if (records.length < 2) throw new Error('CSV-Datei enthält nicht genügend Daten.');
  const headers = records[0];
  if (headers.some(header => !header) || new Set(headers).size !== headers.length) throw new Error('Spaltenüberschriften müssen gefüllt und eindeutig sein.');
  records.slice(1).forEach((record, index) => {
    if (record.length !== headers.length) throw new Error(`Datensatz ${index + 2}: Anzahl der Spalten stimmt nicht mit der Kopfzeile überein.`);
  });
  return records;
}

export function parseFinanceAmount(value: string, thousands: string, decimal: string): number {
  if (thousands && thousands === decimal) throw new Error('Tausender- und Dezimaltrennzeichen müssen verschieden sein.');
  let normalized = value.trim().replace(/[\u00a0\u202f]/g, ' ');
  const parts = normalized.replace(/^[+-]/, '').split(decimal);
  if (parts.length > 2 || (parts.length === 2 && !/^\d{1,2}$/.test(parts[1]))) throw new Error('Ungültiger Betrag.');
  const groups = thousands ? parts[0].split(thousands) : [parts[0]];
  if (!/^\d+$/.test(groups[0]) || (groups.length > 1 && (groups[0].length > 3 || groups.slice(1).some(group => !/^\d{3}$/.test(group))))) throw new Error('Ungültiger Betrag oder falsches Zahlenformat.');
  if (thousands) normalized = normalized.split(thousands).join('');
  normalized = normalized.replace(decimal, '.');
  const amount = Number(normalized);
  if (!Number.isFinite(amount) || !Number.isSafeInteger(Math.round(amount * 100))) throw new Error('Ungültiger Betrag.');
  return amount;
}

export async function readFinanceCsv(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  try { return new TextDecoder('utf-8', { fatal: true }).decode(buffer); }
  catch { return new TextDecoder('windows-1252').decode(buffer); }
}
